import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PermissionsGate from "../PermissionsGate";
import Proposals from "./proposals/Proposals";

const Commerce = () => {
    const moduleName = "commerce";

    return (
        <Routes>
            <Route
                path="proposals/*"
                element={
                    <PermissionsGate module={moduleName} submodule="proposals">
                        <Proposals />
                    </PermissionsGate>
                }
            />
            <Route path="*" element={<Navigate to="proposals" />} />
        </Routes>
    );
};

export default Commerce;
